
<script lang="ts">
import {Component, toNative} from 'vue-facing-decorator'
import ClassInput from "@/components/design/class/ClassInput.vue";
import {NotUniqueError} from "@/errors/errors";
import WorkspaceRouteComponent from "@/components/shared/WorkspaceRouteComponent";
import Idea from "@/types/Idea";
import {emptyIdea, nameProperty} from "@/utils/modelUtils";
import {collectionCreate} from "@/utils/heading";

@Component({components: {'ontos-class-input': ClassInput}})
class CreateClass extends WorkspaceRouteComponent {
  get heading() {
    return collectionCreate(this.workspace)
  }

  idea: Idea = emptyIdea()
  identifiedByName = true
  declare $refs: {input: InstanceType<typeof ClassInput>}

  async save() {
    try {
      if (this.$refs.input.validateModel()) {
        this.idea.properties = this.identifiedByName ? [nameProperty()] : []
        await this.createIdea(this.idea)
        this.info(this.$tt('info.collection-created', {name: this.idea.name}))
        await this.$router.push({name: 'view-idea', params: {...this.$route.params, idea: this.idea.alias}})
      }
    } catch (err) {
      if (err instanceof NotUniqueError) {
        this.$refs.input.notUnique(err.data.property as 'name' | 'pluralName' | 'alias')
      } else this.throwError(this.$tt('error.create-collection', {name: this.idea.name}), err)
    }
  }
}

export default toNative(CreateClass)
</script>
<template>
  <ontos-base v-bind="baseProps" ref="base">
    <v-form ref="form">
      <ontos-page-header v-bind="heading"/>
      <v-row>
        <v-col cols="8">
          <ontos-class-input ref="input" :value="idea" @input="idea = $event" :ideas="workspace.ideas" start-with-auto-alias start-with-auto-plural/>
        </v-col>
        <v-col>
          <v-checkbox v-model="identifiedByName" :label="$tt('identified-by-name')"></v-checkbox>
        </v-col>
        <v-col align-self="center">
          <v-btn size="small" color="primary" @click="save()">
            <v-icon start>mdi-content-save</v-icon>
            {{ $tt('save')}}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </ontos-base>
</template>